import React from 'react';
import InfoDialog from 'swag-client-common/components/info/info-dialog';
import WarningDialog from './components/warning-dialog';
export default function BigAmountOfMockupsPopup(props) {
  const {
    onClose
  } = props;
  return /*#__PURE__*/React.createElement(InfoDialog, {
    subHeader: "Warning",
    header: "Big report",
    content: /*#__PURE__*/React.createElement(WarningDialog, null),
    onRequestClose: onClose,
    showCloseButton: true,
    open: true
  });
}